import { headers, parseJSON } from '../../../../apiUtils';
import store from '../../../../store';

export function fetchCustomerFacingSurvey_(key) {
    return fetch(`/api/CustomerFacingSurvey?key=${key}`, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function sendSurvey(survey) {
    const state = store.getState();
    return fetch('/api/CustomerFacingSurvey', {
        headers: headers(),
        method: 'POST',
        body: JSON.stringify({ Survey: survey, AccessKey: state.customerFacingSurvey.accessKey })
    }).then(parseJSON);
}
